/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory.

import ReactOnRails from 'react-on-rails';
import App from '../components/App';
import Header from '../components/common/Header';
import ErrorPage from '../components/common/ErrorPage';
// jquery import is required here, despite not being called immediately!
import $ from 'jquery';

ReactOnRails.register({
  App,
  Header,
  ErrorPage,
});
